<h1 mat-dialog-title>{{ data.title }}</h1>
<div class="content">
  <mat-spinner color="accent"></mat-spinner>
  <i class="sub-text">{{ data.subText }}</i>
</div>
